export default "<div echarts [options]=\"chartOptions\" class=\"chart\"></div>"